// extracted by mini-css-extract-plugin
export default {"chosenSwitch":"Fields_chosenSwitch__UQfAZ","subtitle":"Fields_subtitle__BVaKJ"};